import { Component, Inject, OnDestroy } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Observable, Subscription } from 'rxjs';

export interface LetzteAktionTierListItem {
    gt_id: number;
    ohrmarke_notnull: string;
    abteil?: string | null;
    viehhaendler_id?: number | null;
    viehhaendler_name?: string | null;
    betriebskontakt_haendler_id?: number | null;
    betriebskontakt_haendler_name?: string | null;
    herkunft_kunde_id?: number | null;
    herkunft_vvvo?: string | null;
    herkunft_betrieb?: string | null;
    herkunft_strasse?: string | null;
    herkunft_plz?: string | null;
    herkunft_ort?: string | null;
    herkunft_ortsteil?: string | null;
}

export interface LetzteAktionenTiereDialogData {
    tiere: LetzteAktionTierListItem[];
    reload?: () => Observable<LetzteAktionTierListItem[]>;
}

interface LetzteAktionenTiereDialogResult {
    tiere: LetzteAktionTierListItem[];
}

@Component({
    selector: 'kiene-letzte-aktionen-tiere-dialog',
    templateUrl: './letzte-aktionen-tiere-dialog.component.html',
    styleUrls: ['./letzte-aktionen-tiere-dialog.component.scss'],
})
export class LetzteAktionenTiereDialogComponent implements OnDestroy {
    tiere: LetzteAktionTierListItem[];
    isReloading = false;
    tierSearchCtrl = new FormControl<string>('', { nonNullable: true });

    private readonly subscriptions = new Subscription();

    constructor(
        @Inject(MAT_DIALOG_DATA) private readonly data: LetzteAktionenTiereDialogData,
        public readonly dialogRef: MatDialogRef<
            LetzteAktionenTiereDialogComponent,
            LetzteAktionenTiereDialogResult
        >,
    ) {
        this.tiere = [...(data.tiere ?? [])];
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }

    get filteredTiereList(): LetzteAktionTierListItem[] {
        const query = this.normalizeTierSearch(this.tierSearchCtrl.value);
        if (!query) {
            return this.tiere;
        }
        return this.tiere.filter(tier => this.normalizeTierSearch(tier.ohrmarke_notnull).includes(query));
    }

    get canReload(): boolean {
        return !!this.data.reload;
    }

    clearTierSearch(): void {
        this.tierSearchCtrl.setValue('');
    }

    reloadTiere(): void {
        if (!this.data.reload || this.isReloading) {
            return;
        }
        this.isReloading = true;
        this.subscriptions.add(
            this.data.reload().subscribe({
                next: records => {
                    this.tiere = records ?? [];
                    this.isReloading = false;
                },
                error: () => {
                    this.isReloading = false;
                },
            }),
        );
    }

    close(): void {
        this.dialogRef.close({ tiere: this.tiere });
    }

    private normalizeTierSearch(value: string | null | undefined): string {
        return (value ?? '').replace(/\s+/g, '').toLowerCase();
    }
}
